import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'

import { useHistory } from '@/router'

import { openEditUserPlugin } from '../../utils/util'

/**
 * 门户管理 添加按钮内容
 *
 * @returns 组件
 */
export const ButtonAddContent: React.FC = () => {
  const history = useHistory()

  return (
    <ButtonBox>
      <ItemBox onClick={() => openEditUserPlugin()}>
        <ImgBox>
          <img src={'/selfapp.svg'} />
        </ImgBox>
        <DescBox>
          <DescTitle>{'推荐应用'}</DescTitle>
          <DescInfo>{'创建第三方网站链接'}</DescInfo>
        </DescBox>
        <div className="icon">
          <GrowpIcon
            name="RightArrow"
            color="#AFBDC7"
          />
        </div>
      </ItemBox>
      <ItemBox onClick={() => history.push('AdminSystemPlugins')}>
        <ImgBox>
          <img src={'/sysapp.svg'} />
        </ImgBox>
        <DescBox>
          <DescTitle>{'单点登录应用'}</DescTitle>
          <DescInfo>{'从商店中申请安装单点登录应用'}</DescInfo>
        </DescBox>
        <div className="icon">
          <GrowpIcon
            name="RightArrow"
            color="#AFBDC7"
          />
        </div>
      </ItemBox>
    </ButtonBox>
  )
}

const ButtonBox = styled.div`
  width: 280px;
  height: 144px;
  border-radius: 12px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 8px;
`

const ItemBox = styled.div`
  width: 264px;
  height: 64px;
  border-radius: 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 8px;
  gap: 8px;
  align-self: stretch;
  .icon {
    display: none;
  }

  &:hover {
    background-color: #f5fafa;
    .icon {
      display: block;
    }
  }

  cursor: pointer;
`

const DescBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px 0px 0px 0px;
  flex-grow: 1;
  width: 196px;
  height: 44px;
  opacity: 1;
  align-items: left;
`

const DescTitle = styled.div`
  height: 22px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: ${(props) => props.theme.text._1};
`

const DescInfo = styled.div`
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.text._3};
`

const ImgBox = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: ${(props) => props.theme.background._3};
`
